module.exports = __webpack_public_path__ + "img/arrow-left.fee009b5.svg";